import { SvgShape } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'

export function getHighlightCenterCoordinates(highlight: SvgShape) {
  switch (highlight.shape) {
    case 'rect':
      return {
        x: highlight['x'] + highlight['width'] / 2,
        y: highlight['y'] + highlight['height'] / 2,
      }
    case 'circle':
      return {
        x: highlight['centerX'],
        y: highlight['centerY'],
      }
    case 'line':
      return {
        x: (highlight['x1'] + highlight['x2']) / 2,
        y: (highlight['y1'] + highlight['y2']) / 2,
      }
    case 'polygon':
      const points = highlight['points'].map((point: string) => {
        const splitedPoint = point.split(',')
        return {
          x: Number(splitedPoint[0].trim()),
          y: Number(splitedPoint[1].trim()),
        }
      })

      const xSum = points.reduce((acc, point) => acc + point.x, 0)
      const ySum = points.reduce((acc, point) => acc + point.y, 0)
      const centerX = xSum / points.length
      const centerY = ySum / points.length
      return {
        x: centerX,
        y: centerY,
      }

    default:
      ShowException(
        'highlights',
        'Need to implement the get center coordinates for the shape: ' +
          highlight.shape,
      )

      return {
        x: -1000,
        y: -1000,
      }
  }
}
